export default {
    username:'نام کاربری',
    name:'نام',
    lastname:'نام خانوادگی',
    status:'وضعیت',
    actions:'فعالیت ها',
    image:'تصویر',
    addNewDoctor:'افزودن پزشک جدید',
    of:'از'
}